(async function () {
  const limit = window.PELI_CART_LIMIT || 12;

  // Only run on pages that have an "Add to cart" form
  const productForms = document.querySelectorAll('product-form form');
  if (!productForms.length) return;

  // Fetch current cart state
  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return null;
    return await res.json();
  }

  function disableForm(formEl, messageEl) {
    const submitButtons = formEl.querySelectorAll('button[type="submit"], input[type="submit"]');
    submitButtons.forEach((btn) => {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    });

    if (messageEl) messageEl.hidden = false;
  }

  function enableForm(formEl, messageEl) {
    const submitButtons = formEl.querySelectorAll('button[type="submit"], input[type="submit"]');
    submitButtons.forEach((btn) => {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
    });

    if (messageEl) messageEl.hidden = true;
  }

  // Insert message under each product form
  for (const formEl of productForms) {
    // Avoid duplicating notice if theme re-renders
    if (formEl.querySelector('.cart-limit-notice')) continue;

    const notice = document.createElement('div');
    notice.className = 'cart-limit-notice';
    notice.hidden = true;
    notice.innerHTML = `
      <div class="cart-limit-notice__title">Large order notice</div>
      <div>For orders over ${limit} items, please contact Sales for assisted ordering.</div>
      <div class="cart-limit-notice__actions">
        <a class="button button--secondary" href="tel:17634124800">Call Sales:(763) 412-4800</a>

      </div>
    `;

    // Place notice directly under the Add to cart button
    const submitBtn = formEl.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) {
      submitBtn.insertAdjacentElement('afterend', notice);
    } else {
      // Fallback: put at end of form
      formEl.appendChild(notice);
    }

    // Initial state
    const cart = await getCart();
    if (cart && cart.item_count >= limit) disableForm(formEl, notice);
    else enableForm(formEl, notice);

    // Re-check on common Shopify/Dawn cart updates
    const refresh = async () => {
      const c = await getCart();
      if (!c) return;
      if (c.item_count >= limit) disableForm(formEl, notice);
      else enableForm(formEl, notice);
    };

    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:updated', refresh);

    // Also re-check when the page regains focus (handy after cart changes in another tab)
    window.addEventListener('focus', refresh);
  }
})();
